import { filter } from 'rxjs/operators';

import {
    AbstractPlugin,
    MediaPlayerEvents,
} from 'mlb-internal-embed';

import { DateUtils } from '../../../../utils';
import { Tracking } from 'bdvp-tracking';

const MEDIA_ITEM_SET = MediaPlayerEvents.MEDIA_PLAYER.MEDIA_ITEM_SET;
const MEDIA_START = MediaPlayerEvents.HTML5.MEDIA_START;
const MEDIA_COMPLETE = MediaPlayerEvents.HTML5.MEDIA_COMPLETE;

class GoogleAnalyticsPlugin extends AbstractPlugin {

    constructor(config, observationCenter) {

        super(config, observationCenter);

        this.googleAnalyticsConfig = this.config?.googleAnalytics ?? {};
        this.playerSubject = this.observationCenter.playerSubject;

        this.playbackStart = false;

    }

    setMediaPlayer(mediaPlayer) {

        if(!this.googleAnalyticsConfig.enabled) {

            return;

        }

        this.mediaPlayer = mediaPlayer;
        this.unsubscribe();
        this.subscribeToMessages();
        super.setMediaPlayer(this.mediaPlayer);

    }

    subscribeToMessages() {

        // If a new media item is set, make sure playbackStart is set back to false
        this.subscriptions.push(

            this.playerSubject.pipe(filter((event) => {

                return event.type === MEDIA_ITEM_SET;


            })).subscribe(() => {

                this.playbackStart = false;

            })
        );

        // Fired for 'play'
        this.subscriptions.push(

            this.playerSubject.pipe(filter((event) => {

                return event.type === MEDIA_START;

            })).subscribe(({ type }) => {

                if (!this.playbackStart) {

                    this.playbackStart = true;
                    this.trackVideoEvent(type);

                }

            })
        );

        // Fired for 'end'
        this.subscriptions.push(

            this.playerSubject.pipe(filter((event) => {

                return event.type === MEDIA_COMPLETE;

            })).subscribe(({ type }) => {

                this.playbackStart = false;
                this.trackVideoEvent(type);

            })
        );

    }

    unsubscribe() {

        this.subscriptions.forEach((subscription) => {

            subscription.unsubscribe();

        });

    }

    trackVideoEvent(eventType) {

        const currentMediaItem = this.mediaPlayer.player?.currentMediaItem || {};

        const { metaData = {} } = currentMediaItem;
        const {
            title = '',
            slug = '',
            duration = '',
        } = metaData;

        switch (eventType) {

            case MEDIA_START:
                Tracking.trackVideoStart({
                    title,
                    slug,
                    duration,
                });
                break;

            case MEDIA_COMPLETE:
                const playtimeSeconds = DateUtils.formatDurationToSeconds(duration);
                Tracking.trackVideoComplete({
                    title,
                    slug,
                    duration,
                    playtimeSeconds,
                });
                break;

        }

    }

    toString() {

        return 'GoogleAnalyticsPlugin';

    }

}

export default GoogleAnalyticsPlugin;
